import { Chain, ChainInfo } from "./types";

export const SOURCE_CHAINS = [
  "mainnet",
  "goerli",
  "gnosis",
] as const satisfies readonly Chain[];

export type SourceChain = (typeof SOURCE_CHAINS)[number];

export const DESTINATION_CHAINS = {
  goerli: [
    "arbitrum",
    "avalanche",
    "binance",
    "gnosis",
    "goerli",
    "optimism",
    "polygon",
    "mainnet",
  ],
  mainnet: [
    "arbitrum",
    "avalanche",
    "binance",
    "gnosis",
    "goerli",
    "optimism",
    "polygon",
    "mainnet",
  ],
  gnosis: [
    "arbitrum",
    "avalanche",
    "binance",
    "gnosis",
    "goerli",
    "optimism",
    "polygon",
    "mainnet",
  ],
} as const satisfies { [K in SourceChain]: readonly Chain[] };

export type DestinationChain = (typeof DESTINATION_CHAINS)[SourceChain][number];

export const CHAINS: { [key in Chain]: ChainInfo } = {
  goerli: {
    chainId: 5,
    scanUrl: "https://goerli.etherscan.io/",
    beaconScanUrl: "https://goerli.beaconcha.in/",
    nodeUrl: "https://prysm-goerli.succinct.xyz/",
    name: "Goerli",
  },
  mainnet: {
    chainId: 1,
    scanUrl: "https://etherscan.io/",
    beaconScanUrl: "https://beaconcha.in/",
    nodeUrl: "https://prysm-mainnet.succinct.xyz/",
    name: "Ethereum",
  },
  polygon: {
    chainId: 137,
    scanUrl: "https://polygonscan.com/",
    name: "Polygon",
  },
  optimism: {
    chainId: 10,
    scanUrl: "https://optimistic.etherscan.io/",
    name: "Optimism",
  },
  gnosis: {
    chainId: 100,
    beaconScanUrl: "https://beacon.gnosischain.com/",
    nodeUrl: "https://teku-gnosis.succinct.xyz/",
    scanUrl: "https://gnosisscan.io/",
    name: "Gnosis",
  },
  arbitrum: {
    chainId: 42161,
    scanUrl: "https://arbiscan.io/",
    name: "Arbitrum",
  },
  binance: {
    chainId: 56,
    scanUrl: "https://bscscan.com/",
    name: "Binance",
  },
  avalanche: {
    chainId: 43114,
    scanUrl: "https://snowtrace.io/",
    name: "Avalanche",
  },
};

export default CHAINS;
